module.exports = __webpack_public_path__ + "ru.svg?80428218456fc95fa176f1ebdaeba60d";